import ArrowLeftIcon from 'lucide-react/dist/esm/icons/arrow-left';
import CircleAlertIcon from 'lucide-react/dist/esm/icons/circle-alert';
import { useEffect } from 'react';

import { Button } from '@/components/ui/Button';

export function ApplicationError() {
  useEffect(() => {
    // Inertia unmounts with the failed tree, so same-document history needs a full page load.
    const reloadPreviousPage = () => window.location.reload();
    window.addEventListener('popstate', reloadPreviousPage);

    return () => window.removeEventListener('popstate', reloadPreviousPage);
  }, []);

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background p-6 text-foreground">
      <div role="alert" className="flex max-w-md flex-col items-center gap-4 text-center">
        <CircleAlertIcon aria-hidden="true" className="size-10 text-muted-foreground" />
        <h1 className="text-2xl font-semibold">An error occurred</h1>
        <p className="text-sm text-muted-foreground">
          We could not display this page. Go back to the previous page and try again.
        </p>
        <Button type="button" onClick={() => window.history.back()}>
          <ArrowLeftIcon aria-hidden="true" className="size-4" />
          Back
        </Button>
      </div>
    </main>
  );
}
